import { Spacing } from '@persona-id/design-tokens';
import { FONT_SIZES } from 'shared/styles/variables';
import styled from 'styled-components';

import { COLORS } from 'dashboard/styles/variables';
import IconAlertCircle from 'images/icons/alert-circle.svg';

export const FormWarning = styled('div')`
  display: inline-flex;
  align-items: center;
  color: ${COLORS.gray100};
  font-size: ${FONT_SIZES.small};
  margin-top: ${Spacing[2]};
`;

export const IconAlertCircleStyled = styled(IconAlertCircle)`
  position: relative;
  margin-right: ${Spacing[2]};
  width: ${Spacing[4]};
  path,
  rect {
    stroke: ${COLORS.gray100};
  }
`;

export default FormWarning;
